<template>
  <div style="width: 100%;height: 100%;overflow: hidden;color: white">
    <div class="nothing-data" v-if="yData.length === 0"></div>
    <div v-else style="height: 100%;width: 100%;margin: auto 0" ref="wrapShow"></div>
    <div class="box-three" v-if="false">
      <div style="margin: 0 20px">
        <div class="img-top">
          <el-row style="text-align: center">
            <el-col :span="12">
              <img src="../../../assets/SHscreen/index_dispatch_1.png">
            </el-col>
            <el-col :span="12">
              <img src="../../../assets/SHscreen/index_dispatch_2.png">
            </el-col>
          </el-row>
        </div>
        <div class="text-top1">
          <el-row style="text-align: center">
            <el-col :span="12">
              <span>紧急救援服务</span>
            </el-col>
            <el-col :span="12">
              <span>咨询服务</span>
            </el-col>
          </el-row>
        </div>
        <div class="text-top2">
          <el-row style="text-align: center">
            <el-col :span="12">
              <span style="color: #33ffff">{{servicecount0}}</span>
            </el-col>
            <el-col :span="12">
              <span style="color: #ffcc33">{{servicecount1}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
      <div style="margin: 0 20px">
        <div class="img-top">
          <el-row style="text-align: center">
            <el-col :span="12">
              <img src="../../../assets/SHscreen/index_dispatch_3.png">
            </el-col>
            <el-col :span="12">
              <img src="../../../assets/SHscreen/index_dispatch_4.png">
            </el-col>
          </el-row>
        </div>
        <div class="text-top1">
          <el-row style="text-align: center">
            <el-col :span="12">
              <span>代办代叫</span>
            </el-col>
            <el-col :span="12">
              <span>辅助就医</span>
            </el-col>
          </el-row>
        </div>
        <div class="text-top2">
          <el-row style="text-align: center">
            <el-col :span="12">
              <span style="color: #3399ff">{{servicecount2}}</span>
            </el-col>
            <el-col :span="12">
              <span style="color: #33ff77">{{servicecount3}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'indexSendOrders',
  data () {
    return {
      servicetype: [],
      servicecount0: 0,
      servicecount1: 0,
      servicecount2: 0,
      servicecount3: 0,
      serviceArr: [],
      yData: [],
      xData: []
      // '紧急救援服务', '咨询服务', '代办代叫', '辅助就医'
    }
  },
  created () {
    // 今日派单次数
  },
  methods: {
    getRefresh (arr) {
      console.log('派单次数', arr)
      this.servicetype = arr
      this.getStartData()
    },
    getStartData () {
      let arr = this.servicetype
      let yData = []
      let xData = []
      for (let i = 0; i < arr.length; i++) {
        yData.push(arr[i].servicecount)
        xData.push(arr[i].servicetype)
        if (arr[i].servicetype === '紧急救援服务') {
          this.servicecount0 = arr[i].servicecount
        } else if (arr[i].servicetype === '咨询服务') {
          this.servicecount1 = arr[i].servicecount
        } else if (arr[i].servicetype === '代办代叫') {
          this.servicecount2 = arr[i].servicecount
        } else if (arr[i].servicetype === '辅助就医') {
          this.servicecount3 = arr[i].servicecount
        }
      }
      this.yData = yData
      this.xData = xData
      let vm = this
      setTimeout(() => {
        vm.getChartDataShow()
      }, 300)
      // console.log(this.servicecount0)
    },
    getChartDataShow () {
      // console.log(this.yData)
      // console.log(this.xData)
      if (this.yData.length === 0) {
        return
      }
      let chart = this.$echarts.init(this.$refs.wrapShow)
      chart.setOption({
        color: ['rgb(255, 168, 0)'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: '3%',
          left: '4%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.xData,
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1
              }
            },
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: { // X轴文字倾斜
              interval: 0,
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            name: '',
            min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#182f4d',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          }
        ],
        series: [
          {
            name: '数量',
            type: 'bar',
            barWidth: '60%',
            data: this.yData
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
.box-three{
  position: relative;
  width: 100%;
  height: 190px;
  top: 50%;
  margin-top: -95px;
}
.img-top{
  height: 40px;
}
.img-top img{
  width: 39px;
  height: 40px;
}
.text-top1{
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #e1e3ef;
}
.text-top2{
  height: 30px;
  line-height: 30px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexSendOrders.vue